export const USER_DOCUMENT_HEADERS = [
  {
    key: 'url',
    label: 'File link',
    type: 'url',
  },
  {
    key: 'createdAt',
    label: 'Upload date',
    type: 'date',
  },
  {
    key: 'uploader',
    label: 'Uploaded by',
    type: 'string',
  },
  {
    key: 'outcome',
    label: 'Outcome',
    type: 'string',
  },
  {
    key: 'rejectReason',
    label: 'Tips for BA',
    type: 'input',
  },
  {
    key: 'comment',
    label: 'Comment',
    type: 'input',
  },
  {
    key: 'status',
    label: 'Actions',
    type: 'actions',
  },
]
